module.exports = "<p><a href=\"introduction/committee\">理事会成员</a> 可以提议修改区块链的动态参数，比如手续费，区块间隔时间以及其他很多参数。这是一个需要对BitShares系统如何运作有很深理解，需要有很强责任感的职位。</p>\n";